// extracted by css-extract-rspack-plugin
export default {"baseLink":"Mfnbj","disabled":"T6EOH"};